import {RouterModule, Routes} from "@angular/router";
import {WebsitesComponent} from "./websites.component";
import {NgModule} from "@angular/core";

const routes: Routes = [
  { path: 'websites', component: WebsitesComponent }
];

@NgModule ({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})

export class WebsitesRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/websites/websites-routing.module.ts